import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardContent, CardActions, Button, Grid, CircularProgress, MenuItem } from '@material-ui/core';
import { SimpleFileUpload, TextField } from 'formik-material-ui';
import { Formik, Form, Field } from 'formik';
import { getDocFileTypeDomains, addDocument } from 'utils/DocumentsUtils';
import { useAppContext } from 'hooks/useAppContext';

const AddDocumentForm = ({ callback: submitCallback }) => {
  const { selectedProject } = useAppContext();
  const [fileTypes, setFileTypes] = useState([]);

  useEffect(() => {
    let mounted = true;
    const getReferences = async () => {
      const fileTypes = await getDocFileTypeDomains();
      setFileTypes(fileTypes);
    }
    mounted && getReferences();
    return () => { mounted = false };
  }, []);

  const validate = (values) => {
    const errors = {};
    if (!values.value) {
      errors.value = 'File is Required';
    };
    if (values.DocFileDestinationId.length === 0) {
      errors.DocFileDestinationId = 'File Type is Required';
    };
    return errors;
  };

  const onSubmit = async (values, actions) => {
    values.ProjectId = selectedProject;
    const result = await addDocument(values);
    actions.setSubmitting(false);
    if(result.success){
      actions.resetForm();
      submitCallback();
    }
  }

  return (
    <Grid container justify="center" style={{ padding: 16 }}>
      <Card>
        <Formik
          validate={validate}
          initialValues={{
            value: null,
            DocFileDestinationId: '',
            Description: ''
          }}
          onSubmit={onSubmit}
        >
          {(params) => {
            return (
              <>
                {
                  !params.isSubmitting ? <Form>
                    <CardHeader id="form-Card-title" title="Upload Attachment"></CardHeader>
                    <CardContent>
                      <Field
                        component={SimpleFileUpload}
                        name="value"
                        label="Upload a file"
                        onChange={(event) => {
                          params.setFieldValue("value", event.currentTarget.files[0])
                        }}
                      />
                      <Field
                        component={TextField}
                        select={true}
                        name="DocFileDestinationId"
                        label="File Destination"
                        style={{ width: "100%" }}
                        inputProps={{
                          id: 'DocFileDestinationId',
                        }}
                      >
                        {fileTypes.length > 0 ? fileTypes.map(r => (<MenuItem key={r.domainId} value={r.domainId}>{r.description}</MenuItem>)) : <MenuItem key='na' value='na'>na</MenuItem>}
                      </Field>
                      <Field
                        component={TextField}
                        label="File Description"
                        name="Description"
                        style={{ width: "100%" }}
                      />
                    </CardContent>
                    <CardActions>
                      <Button color="primary" type="submit" variant="contained"> Attach File</Button>
                    </CardActions>
                  </Form> : <CircularProgress></CircularProgress>
                }
              </>
            )
          }}
        </Formik>
      </Card>
    </Grid>
  )
}

export default AddDocumentForm;